module.exports = __webpack_public_path__ + "static/media/knihovna.e82b25f6.jpg";